import { useNavigate } from "react-router";
import { QuotaBanner } from "./quota-banner";
import { useUsage } from "@/lib/hooks/use-usage";
import { useCurrentRole } from "@/lib/hooks/use-current-role";
import { useUsageBannerStore } from "@/lib/stores/usage-store";

/**
 * Quota banner connected to the usage data and store.
 * Handles:
 * - Fetching usage data
 * - Dismissal state persistence
 * - Navigation to billing page for upgrades, for a role that can change the
 *   plan; anyone else still sees the warning
 */
export function ConnectedQuotaBanner() {
  const navigate = useNavigate();
  const { data, isLoading } = useUsage();
  const { shouldShowBanner, dismissBanner } = useUsageBannerStore();
  const { can } = useCurrentRole();

  // Don't render while loading or if no data
  if (isLoading || !data) {
    return null;
  }

  // Check if banner should be shown based on status and dismissal state
  if (!shouldShowBanner(data.status)) {
    return null;
  }

  const handleDismiss = () => {
    dismissBanner(data.status);
  };

  const handleUpgrade = () => {
    navigate("/dashboard/settings/billing");
  };

  return (
    <QuotaBanner
      status={data.status}
      reportCount={data.reportCount}
      softExceededCount={data.softExceededCount}
      limit={data.limit}
      onDismiss={handleDismiss}
      onUpgrade={can("POST /checkout/session") ? handleUpgrade : undefined}
    />
  );
}
